import { render, staticRenderFns } from "./footer2022.vue?vue&type=template&id=c2f3be6e&scoped=true"
import script from "./footer2022.vue?vue&type=script&lang=js"
export * from "./footer2022.vue?vue&type=script&lang=js"
import style0 from "./footer2022.vue?vue&type=style&index=0&id=c2f3be6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f3be6e",
  null
  
)

export default component.exports